import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { mediaQuery } from '@design-system/Breakpoints/Breakpoints';
import { useDispatch, useSelector } from 'react-redux';
import { getUser } from '@app/auth/redux/selectors';
import down from '@design-system/Assets/chevron-down.png';
import up from '@design-system/Assets/chevron-up.png';
import User from '@design-system/Assets/User.png';
import logout from '@design-system/Assets/log-out.png';
import { Link } from 'react-router-dom';
import { getProfileDetails } from '@app/profile/redux/selectors';
import { get_profile_details } from '@app/profile/redux/reducer';

const PageLayoutStyle = styled.main`
  padding-top: 0.1rem;
  grid-area: content;
  margin-top: 2rem;
  overflow-x: hidden;

  ${mediaQuery.desktop`
  margin: 0.2rem 0.5rem;
  display: grid;
  padding: 0px 1.5rem;
  margin-top: 5rem;
    `}

  ${mediaQuery.large`
  grid-template-columns: 1fr auto;
    `}
  .main {
    ${mediaQuery.desktop`
      margin: 0 2rem;
    `}
    margin: 0 1.5rem;
  }
  .button-left {
    ${mediaQuery.desktop`
    display: flex;
    justify-content: flex-end;
    margin-left: 3rem;
    `}
    display: flex;
    justify-content: flex-end;
    margin-top: 1rem;

    ${mediaQuery.desktop`
    margin: 0rem 0rem;
    `}
  }

  .aside-tab {
    ${mediaQuery.desktop`
    margin: 0 0;
    padding: 0;
    `}
    margin: 1rem 0;
    padding: 2rem;
    padding-bottom: 5rem;
    max-height: 100vh;
    overflow-y: scroll;
  }
`;

const Header = styled.div`
  background: white;
  position: fixed;
  width: 81.5%;
  margin-top: 1px;
  padding: 5px;
  margin-bottom: 20px;
  margin-left: 10px;
  z-index: 4;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  align-content: center;
  top: 0;

  .profile {
    display: flex;
    align-items: center;
    align-content: center;
  }

  .profile-circle {
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    border-radius: 100%;
    background: #549a9a;
    margin-right: 10px;
  }

  .profile-image {
    width: 32px;
    height: 32px;
    object-fit: cover;
    border-radius: 100%;
  }

  img {
    margin-right: 20px;
    cursor: pointer;
  }

  .dropdown {
    display: inline-block;
    position: relative;
  }

  .hide {
    display: none;
  }

  .dropdown-content {
    display: block;
    position: absolute;
    overflow: none;
    box-shadow: 0px 0px 6px 4px rgba(0, 0, 0, 0.07);
    border-radius: 10px;
    background: #fff;
    color: black;
    right: 0;
    margin-top: 20px;
    width: 200.4px;
    height: auto;
  }

  .item-link {
    color: #4f4f4f;
    font-weight: 500;
    font-size: 15px;
    border-bottom: 1px solid #e0e0e0;
    padding: 10px;
    width: auto;
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    text-decoration: none;
  }

  .item-links {
    color: #549a9a;
    font-weight: 500;
    font-size: 15px;
    padding: 10px;
    width: auto;
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    text-decoration: none;
  }
`;

const PageLayout = ({ children }) => {
  const [open, setOpen] = useState(true);
  const user = useSelector(getUser);
  const profile = useSelector(getProfileDetails);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(get_profile_details());
  }, [dispatch]);

  return (
    <PageLayoutStyle>
      <Header>
        <div className="profile">
          <div className="profile-image">
            {profile.photo_url ? (
              <img src={profile.photo_url} alt="profile" className="profile-image" />
            ) : (
              <div className="profile-circle">
                {user.first_name.charAt(0)}
                {user.last_name.charAt(0)}
              </div>
            )}
          </div>
          <p
            style={{
              color: '#4F4F4F',
              fontSize: '15px',
              fontWeight: '500',
              marginRight: '10px',
              paddingLeft: '5px',
            }}
          >
            {' '}
            {profile.first_name}
          </p>
          <div className="dropdown">
            {open ? (
              <img src={down} alt={down} onClick={() => setOpen(!open)} />
            ) : (
              <img src={up} alt={up} onClick={() => setOpen(!open)} />
            )}

            <div className={open ? 'hide' : 'dropdown-content'}>
              <Link className="item-link" to="/profile">
                <img src={User} alt={User} />
                My Account
              </Link>
              <Link className="item-links" to="/logout">
                <img src={logout} alt={logout} />
                Log Out
              </Link>
            </div>
          </div>
        </div>
      </Header>
      {children}
    </PageLayoutStyle>
  );
};

export default PageLayout;

PageLayout.propTypes = {
  children: PropTypes.node.isRequired,
};
